var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},_vm._l((3),function(n){return _c('b-row',{key:n,staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-skeleton',{attrs:{"height":"300px"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }